import React, { FC, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Images } from "../../../../assets/assets";
import '../../Common/FeaturedProjects/FeaturedProjects.css';
import PaginationBar from '../../Common/Pagination/Pagination';
import Loader from '../../../Loader';
import { useGalleryStore } from '../../../../store/useGalleryStore';
import { useProjectStore } from '../../../../store/useProjectStore';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import './ImageGallery.css';
import lgShare from 'lightgallery/plugins/share';
import lgHash from 'lightgallery/plugins/hash';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export default function ResidentialGallery() {
  let { getgalleryimage, gallery } = useGalleryStore();

  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(6);
  const [totalItems, setTotalItems] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const getPageData = async () => {
    setLoading(true)
    const res = await getgalleryimage('', '', '', '',);
    if (res) {
      setTotalItems(res?.totalItems);
    }
    setLoading(false)
  };

  useEffect(() => {
    getPageData();
  }, [pageNumber, pageSize]);

  const handleChangePagination = (event, value) => {
    setPageNumber(event);
  };

  useEffect(() => {
    // Ensure the DOM element exists
    const container = document.querySelector('.masonry-gallery-demo');
    if (container) {
      // Initialize Masonry
      const msnry = new Masonry(container, {
        itemSelector: '.gallery-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
      });

      // Use imagesLoaded with Masonry
      imagesLoaded(container).on('progress', function () {
        // Layout Masonry after each image loads
        msnry.layout();
      });
    }
  }, []);
  return (
    <section className="featured-projects pt-5 mt-3">
      <Loader loading={loading}>
        {
          (gallery || []).map((ele, idx) => (
            <div key={idx} className="pb-5 mb-3">
              <Container>
                <div className="text-center">
                  <h3 className="section-title">
                    {/* {projectPage?.title} */}
                    {ele?.title}
                  </h3>
                  <p className="section-desc text-light-gray fs-6 mt-xl-3 mt-3 d-block mb-xl-4 mb-lg-4 mb-3">
                    <p>
                      {ele?.description?.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </p>
                </div>
              </Container>
              <Container className="theme-container">

               <div className="gap-3 d-flex flex-wrap justify-content-center galleryMainWidth">
                  {
                    (ele?.image || []).map((proj, index) => (
                      <div key={index} className="galleryWidthimg">
                        <div className="gallery-card">
                          <LightGallery
                            elementClassNames={'masonry-gallery-demo'}
                            plugins={[lgZoom, lgShare, lgHash]}
                            speed={500}
                          >
                            <div className="grid-sizer"></div>
                            <div
                              className="gallery-item"
                              data-src={proj?.imageLink}>
                              <img
                                className="img-fluid"
                                src={proj?.imageLink}
                                alt="gallery"
                              />
                            </div>
                          </LightGallery>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </Container>
            </div>
          ))
        }
      </Loader>

      {/* <div className="paginationDiv">

        <PaginationBar
          totalItems={totalItems}
          pageSize={pageSize}
          currentPage={pageNumber}
          handleChangePagination={handleChangePagination}
        />
      </div> */}
    </section>
  );
}
